import { USERS_GROUPS } from "../lib/constants/actions";



export const addUserGroup = (data) => {
    return {
        type: USERS_GROUPS.ADD_GROUPS,
        payload: data
    }
}

export const addUserGroupSuccess = (data) => {
    return {
        type: USERS_GROUPS.ADD_GROUPS_SUCCESS,
        payload: data
    }
}

export const getUsersGroups = (data) => {
    return {
        type: USERS_GROUPS.LIST_GROUPS,
        payload: data
    }
}

export const getUsersGroupsSuccess = (data) => {
    return {
        type: USERS_GROUPS.LIST_GROUPS_SUCCESS,
        payload: data
    }
}

export const getUsersGroupsArray = (data) => {
    return {
        type: USERS_GROUPS.GET_GROUPS_ARRAY,
        payload: data
    }
}

export const getUsersGroupsArraySuccess = (data) => {
    return {
        type: USERS_GROUPS.GET_GROUPS_ARRAY_SUCCESS,
        payload: data
    }
}

export const assignUserGroups = (data) => {
    return {
        type: USERS_GROUPS.ASSIGN_USER_GROUPS,
        payload: data
    }
}

export const assignUserGroupsSuccess = (data) => {
    return {
        type: USERS_GROUPS.ASSIGN_USER_GROUPS_SUCCESS,
        payload: data
    }
}








